module.exports = "https://static.zego.com/_next/static/images/cyclist-560d950850d27584a95d24b942008b80.svg";